export default function createServiceTranslations(translations) {
  if (!translations) {
    return {};
  }

  return Object.entries(translations)
    .reduce((acc, [key, localeTranslation]) => {
      acc[key] = {
        name: localeTranslation?.name ?? '',
        exampleLink: localeTranslation?.example_link ?? '',
        speed: localeTranslation?.speed ?? '',
        geo: localeTranslation?.geo ?? '',
        requirements: localeTranslation?.requirements ?? '',
        guarantee: localeTranslation?.guarantee ?? '',
        startTime: localeTranslation?.start_time ?? '',
        shortDescription: localeTranslation?.short_description ?? '',
        reviews: localeTranslation?.reviews ?? '',
        description: localeTranslation?.description ?? '',
        metaDescription: localeTranslation?.meta_description ?? '',
        metaTitle: localeTranslation?.meta_title ?? '',
      };

      return acc;
    }, {});
}
